export default "__VITE_ASSET__ODX93jAwQ7z$QOEUuCl0SQ__"